import { render, staticRenderFns } from "./materials-list-table-bulks.vue?vue&type=template&id=ae792bb6&scoped=true"
import script from "./materials-list-table-bulks.vue?vue&type=script&lang=js"
export * from "./materials-list-table-bulks.vue?vue&type=script&lang=js"
import style0 from "./materials-list-table-bulks.vue?vue&type=style&index=0&id=ae792bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae792bb6",
  null
  
)

export default component.exports